import { render, staticRenderFns } from "./roundtableRoomThree.vue?vue&type=template&id=77f5e1f8"
import script from "./roundtableRoomThree.vue?vue&type=script&lang=js"
export * from "./roundtableRoomThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports